import { render, staticRenderFns } from "./ProconNumberOfComplaintsSixMonths.vue?vue&type=template&id=1079ccce&"
import script from "./ProconNumberOfComplaintsSixMonths.vue?vue&type=script&lang=ts&"
export * from "./ProconNumberOfComplaintsSixMonths.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports